import { render } from "./low.vue?vue&type=template&id=0e28a044&ts=true"
import script from "./low.vue?vue&type=script&lang=ts"
export * from "./low.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\operationmanualNew\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__